import color from "@constants/color";
import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import Success from "@assets/svg/MyTasks/Success";

interface PaymentComponentProps {
  collectible_amount: string;
  paymentMode: string;
}

const PaymentComponent: React.FC<PaymentComponentProps> = ({
  collectible_amount,
  paymentMode,
}) => {
  const renderCashComponent = useMemo(() => {
    return (
      <View style={styles.container}>
        <Text variant="subtitle_16" style={styles.whiteText}>
          कस्टमर से कैश लेना है:
        </Text>
        <Text style={styles.amountText}>₹{collectible_amount}</Text>
      </View>
    );
  }, [collectible_amount]);
  const renderOnlineComponent = useMemo(() => {
    return parseInt(collectible_amount, 10) > 0 ? (
      <View style={[styles.container, styles.onlineContainer]}>
        <Success />
        <Text variant="subtitle_16" style={styles.successText}>
          Payment Successful
        </Text>
        <Text variant="body_text_2" style={styles.whiteText}>
          {`कस्टमर से ₹${collectible_amount} ऑनलाइन प्राप्त हो गया !`}
        </Text>
      </View>
    ) : null;
  }, [collectible_amount]);
  return (
    <View>
      {paymentMode === "COD"
        ? renderCashComponent
        : paymentMode === "PREPAID"
          ? renderOnlineComponent
          : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 16,
    paddingBottom: 4,
    margin: 8,
    width: "98%",
  },
  whiteText: {
    color: color.white,
    textAlign: "center",
  },
  amountText: {
    color: color.white,
    fontSize: 36,
    textAlign: "center",
    fontWeight: "bold",
  },
  onlineContainer: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  successText: {
    color: color.white,
    textAlign: "center",
    marginTop: 8,
  },
});

export default PaymentComponent;
